import { useTypedParams } from '@sorare/routing';

import { WatchlistsLayout } from '@sorare/marketplace/src/components/watchlists/WatchlistsLayout';

import { LayoutParams } from './__generated__/routeParams';

export const WatchlistLayout = () => {
  const { id } = useTypedParams<LayoutParams>();
  return <WatchlistsLayout id={id} />;
};

export default WatchlistLayout;
